export default __webpack_public_path__ + "static/media/janetMelody.ce655ebd.jpg";